import React, { ReactNode, use } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export const SidebarSectionContainer = styled.div`
  background-color: white;
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.875rem;
`;

export const SectionHeader = styled.div`
  color: white;
  padding: 0.5rem 0.75rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #ef4444;
  background-color: white;
  color: #111827;
`;

export const SectionMore = styled.div`
  font-size: 0.7rem;
  color: #6b7280;
  cursor: pointer;
  
  &:hover {
    color: #ef4444;
    text-decoration: underline;
  }
`;

export const SectionContent = styled.div`
  padding: 0.5rem;
`;

export const NoDataText = styled.div`
  color: #6b7280;
  font-size: 0.875rem;
  padding: 0.5rem;
`;

interface SidebarSectionProps {
  title: string;
  moreLink?: string;
  children: ReactNode;
}

const SidebarSection: React.FC<SidebarSectionProps> = ({ 
  title, 
  moreLink, 
  children 
}) => {
  const navigate = useNavigate()
  return (
    <SidebarSectionContainer>
      <SectionHeader>
        <span>{title}</span>
        {moreLink && <SectionMore onClick={()=>{
          navigate(moreLink);
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }}>더보기</SectionMore>}
      </SectionHeader>
      <SectionContent>
        {children}
      </SectionContent>
    </SidebarSectionContainer>
  );
};

export default SidebarSection; 